<template>
  <div
    class="w-100 h-100 d-flex justify-content-center align-items-center mt-n5"
  />
</template>

<script>
// import Main from '@/components/Features/Main.vue';

export default {
  components: {
    // Main
  },
  data() {
    return {
    };
  },
  created() {
  }
};
</script>
